#!/usr/bin/env node

import { main } from './bin';

main(undefined, { '--transpileOnly': true });
